import { useEffect, useState } from 'react'

import { Input } from '@skytech/ui'
import { Container } from '@skytech/ui/Container'
import { useDebounce } from '@skytech/utils'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import Tabs from '@/components/Tabs'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import { SDA_STATUS_ID } from './constants'
import SalaryDeductionApplicationList from './SalaryDeductionList'

import './SalaryDeductionPage.styles.scss'

const SalaryDeductionPage = () => {
  const navigate = useNavigate()
  const translate = useTranslation()

  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')
  const [querySearch, setQuerySearch] = useSearchParamsByKey('search')

  const [searchFilter, setSearchFilter] = useState(querySearch || '')
  const [statusFilter, setStatusFilter] = useState(Number(queryStatus) || SDA_STATUS_ID.NEW)

  const debouncedSearchTerm = useDebounce(searchFilter, 500)

  useEffect(() => {
    setSearchFilter(querySearch || '')
    setStatusFilter(Number(queryStatus) || SDA_STATUS_ID.NEW)
  }, [querySearch, queryStatus])

  useEffect(() => {
    setQuerySearch(debouncedSearchTerm)
  }, [debouncedSearchTerm, setQuerySearch])

  const STATUS_FILTER_OPTIONS = [
    { value: SDA_STATUS_ID.ALL, label: <Translation id="sda_status/ALL" /> },
    { value: SDA_STATUS_ID.NEW, label: <Translation id="sda_status/NEW" /> },
    { value: SDA_STATUS_ID.APPROVED, label: <Translation id="sda_status/APPROVED" /> },
    { value: SDA_STATUS_ID.DENIED, label: <Translation id="sda_status/DENIED" /> },
  ]

  return (
    <Container onSwipedLeft={() => navigate('/')} className="sda-list">
      <Container.Header>
        <Translation id="Salary Deduction Applications" />
      </Container.Header>

      <div className="sda-list__filters">
        <div className="sda-list__filters__filter">
          <Tabs
            selectedValue={statusFilter}
            tabs={STATUS_FILTER_OPTIONS}
            onClick={statusId => {
              setStatusFilter(Number(statusId))
              setQueryStatus(statusId)
            }}
          />
        </div>

        <div className="sda-list__filters__filter">
          <Input
            id="sda-search-input"
            value={searchFilter}
            placeholder={translate('Search')}
            onChange={e => setSearchFilter(e.target.value)}
          />
        </div>
      </div>

      <SalaryDeductionApplicationList searchFilter={searchFilter} statusFilter={statusFilter} />
    </Container>
  )
}

export default SalaryDeductionPage
